import { QAItem } from "../productQA-item";

class Pub {
  private qaValues: Map<number, { question?: string; answer?: string; trigger?: string; remark?: string; }> = new Map();
  constructor() {}
  private editCallbacks: Map<string, Function> = new Map();

  subscribe(id: number, prop: string, callback: Function) {
    this.editCallbacks.set(`${prop}-${id}`, callback);
  }

  onChange(id: number, prop: string, value: string) {
    if (this.qaValues.has(id)) {
      this.qaValues.set(id, { 
        ...this.qaValues.get(id), 
        [prop]: value
      });
    } else {
      this.qaValues.set(id, { [prop]: value });
    }
  }

  publish(id: number, prop: string, value: string) {
    if (this.editCallbacks.has(`${prop}-${id}`)) {
      this.editCallbacks.get(`${prop}-${id}`)!(value);
    }
  }

  get(id: number, pre: QAItem) {
    return {
      ...pre,
      ...(this.qaValues.get(id) || {})
    }
  }
}

export default new Pub();